<template>
  <div>
    <DetailIndex :userPaymentRequestCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-myPaymentRequest',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
